import { useAutoResizeTextarea as y } from "./Hooks/useAutoResizeTextarea.js";
import { useResizeObserver as g } from "./Hooks/useResizeObserver.js";
import { useScrollHeight as k } from "./Hooks/useScrollHeight.js";
import { useAlertDialog as x } from "./Hooks/useAlertDialog.js";
import { ErrorContext as b } from "./Context/ErrorContext.js";
import I from "./Components/FairPrice.js";
import { FairPriceCard as P } from "./Components/FairPriceCard.js";
import { PageWrapper as F } from "./Components/PageWrapper.js";
import T from "./Components/BenchmarkChart.js";
import w from "./Components/BenchmarkSlider.js";
import { jsx as e, jsxs as a } from "react/jsx-runtime";
import { Avatar as _, AlertDialog as n } from "radix-ui";
import { PopoverMenu as A, PopoverMenuItem as B, PopoverMenuSeparator as N } from "./Components/PopoverMenu.js";
import { Wrapper as M, GreyBlock as j, SpacerBlock as R, Row as D, Column as H } from "./Components/Skeleton.js";
import { FilterMenu as z } from "./Components/FilterMenu.js";
import * as v from "react";
import { AlertDialogContext as O } from "./Components/AlertDialogContext.js";
import { Separator as $ } from "./Components/Separator.js";
import { Badge as G } from "./Vivid/Badge.js";
import { c as U } from "./index-Cu0xwYjD.js";
import { never as S } from "./Util/never.js";
import { Button as V } from "./Vivid/Button.js";
import { ButtonGroup as W } from "./Vivid/ButtonGroup.js";
import { C as E, c as L } from "./Card-CcWK3wei.js";
import { CardSection as q, CardSectioned as J } from "./Vivid/CardSectioned.js";
import { Chip as K } from "./Vivid/Chip.js";
import { FileUpload as Q } from "./Vivid/FileUpload.js";
import { FileUploadButton as X } from "./Vivid/FileUploadButton.js";
import { Heading as Y } from "./Vivid/Heading.js";
import { Icon as Z } from "./Vivid/Icon.js";
import { Pagination as rr } from "./Vivid/Pagination.js";
import { Progress as er } from "./Vivid/Progress.js";
import { Spinner as or } from "./Vivid/Spinner.js";
import tr from "./Vivid/StarRating.js";
import { Status as ar } from "./Vivid/Status.js";
import { Radio as nr } from "./Vivid/Radio.js";
import { Text as ir } from "./Vivid/Text.js";
import { Link as cr } from "./Vivid/Link.js";
import { Tooltip as sr } from "./Vivid/Tooltip.js";
import { Snackbar as lr, SnackbarContainer as mr } from "./Vivid/Snackbar.js";
import { Select as pr } from "./Vivid/Select.js";
import { Slider as ur } from "./Vivid/Slider.js";
import { Tabs as dr } from "./Vivid/Tabs.js";
import { VerificationCode as fr } from "./Vivid/VerificationCode.js";
import { Switch as hr } from "./Vivid/Switch.js";
import { TextInput as _r } from "./Vivid/TextInput.js";
import { FormField as vr } from "./Vivid/FormField.js";
import { Textarea as Cr } from "./Vivid/Textarea.js";
import { Checkbox as Sr } from "./Vivid/Checkbox.js";
import "./Util/nil.js";
import "./path-DmeIXEBh.js";
import "./number-BVAsi2tO.js";
import "./index-BOiooPsd.js";
import "./deliverable-DVF715F3.js";
const yr = "_avatarPopoverTrigger_13ckf_1", gr = "_hamburger_13ckf_27", kr = "_avatar_13ckf_1", xr = "_avatarFallback_13ckf_52", p = {
  avatarPopoverTrigger: yr,
  hamburger: gr,
  avatar: kr,
  avatarFallback: xr
}, br = ({
  avatarUrl: o,
  name: r,
  children: u,
  defaultOpen: d = !1,
  onOpenChange: i,
  container: f
}) => {
  const l = r == null ? void 0 : r.trim().split(" ").map((h) => h.slice(0, 1)).join("").toUpperCase();
  return /* @__PURE__ */ e(
    C.PopoverMenu,
    {
      container: f,
      defaultOpen: d,
      onOpenChange: i,
      trigger: /* @__PURE__ */ a("div", { className: p.avatarPopoverTrigger, children: [
        /* @__PURE__ */ e("div", { "aria-label": "Toggle menu", className: p.hamburger }),
        /* @__PURE__ */ a(_.Root, { children: [
          /* @__PURE__ */ e(
            _.Image,
            {
              title: r,
              className: p.avatar,
              src: o
            }
          ),
          /* @__PURE__ */ e(_.Fallback, { className: p.avatarFallback, title: r, children: /* @__PURE__ */ e(t.Text, { size: "14px", weight: "600", children: l }) })
        ] })
      ] }),
      children: u
    }
  );
}, Ir = ({
  children: o,
  closeMenuOnClick: r = !1
}) => /* @__PURE__ */ e(C.PopoverMenuItem, { closeMenuOnClick: r, children: o }), Pr = () => /* @__PURE__ */ e(C.PopoverMenuSeparator, {}), Fr = "_overlay_n9dax_1", Tr = "_overlayShow_n9dax_1", wr = "_content_n9dax_8", Ar = "_contentShow_n9dax_1", Br = "_container_n9dax_23", Nr = "_header_n9dax_29", Mr = "_description_n9dax_35", jr = "_actions_n9dax_39", c = {
  overlay: Fr,
  overlayShow: Tr,
  content: wr,
  contentShow: Ar,
  container: Br,
  header: Nr,
  description: Mr,
  actions: jr
}, Rr = ({
  children: o
}) => {
  const [r, u] = v.useState(
    null
  ), [d, i] = v.useState(!1), f = v.useCallback((m) => {
    u(m), i(!0);
  }, []), l = () => {
    var m;
    i(!1), (m = r == null ? void 0 : r.onCancel) == null || m.call(r);
  }, h = () => {
    i(!1), r == null || r.onConfirm();
  };
  return /* @__PURE__ */ a(O.Provider, { value: { showAlert: f }, children: [
    o,
    r && /* @__PURE__ */ a(n.Root, { open: d, onOpenChange: i, children: [
      /* @__PURE__ */ e(
        n.Overlay,
        {
          onClick: l,
          className: c.overlay
        }
      ),
      /* @__PURE__ */ e(n.Content, { className: c.content, children: /* @__PURE__ */ a(t.Card, { shadow: !0, className: c.container, children: [
        /* @__PURE__ */ a("div", { className: c.header, children: [
          /* @__PURE__ */ e(n.Title, { asChild: !0, children: /* @__PURE__ */ e(t.Heading, { node: "h3", children: r.title }) }),
          /* @__PURE__ */ e(n.Description, { asChild: !0, children: /* @__PURE__ */ e(t.Text, { size: "14px", className: c.description, children: r.description }) })
        ] }),
        /* @__PURE__ */ a("div", { className: c.actions, children: [
          /* @__PURE__ */ e(n.Cancel, { asChild: !0, children: /* @__PURE__ */ e(t.Button, { buttonStyle: "secondary", onClick: l, children: r.cancelText || "Cancel" }) }),
          /* @__PURE__ */ e(n.Action, { asChild: !0, children: /* @__PURE__ */ e(
            t.Button,
            {
              buttonStyle: "destructive",
              onClick: h,
              children: r.actionText
            }
          ) })
        ] })
      ] }) })
    ] })
  ] });
}, Dr = "_banner_vguoj_1", Hr = "_typeInfo_vguoj_10", zr = "_icon_vguoj_13", Or = "_typeCaution_vguoj_18", $r = "_typeAlert_vguoj_26", Gr = "_typeSuccess_vguoj_34", s = {
  banner: Dr,
  typeInfo: Hr,
  icon: zr,
  typeCaution: Or,
  typeAlert: $r,
  typeSuccess: Gr
}, Ur = (o) => {
  switch (o) {
    case "info":
      return s.typeInfo;
    case "caution":
      return s.typeCaution;
    case "alert":
      return s.typeAlert;
    case "success":
      return s.typeSuccess;
    default:
      return S(o);
  }
}, Vr = (o) => {
  switch (o) {
    case "info":
      return t.Icon.statusInfoFilled;
    case "caution":
      return t.Icon.statusCautionFilled;
    case "alert":
      return t.Icon.statusAlertFilled;
    case "success":
      return t.Icon.statusSuccessFilled;
    default:
      return S(o);
  }
}, Wr = (o) => /* @__PURE__ */ a(
  "div",
  {
    className: U(
      s.banner,
      Ur(o.type),
      o.className
    ),
    children: [
      !o.hideIcon && /* @__PURE__ */ e("div", { className: s.icon, children: Vr(o.type) }),
      /* @__PURE__ */ e("div", { children: o.children })
    ]
  }
), t = {
  Badge: G,
  Banner: Wr,
  Button: V,
  ButtonGroup: W,
  Card: E,
  CardSection: q,
  CardSectioned: J,
  Chip: K,
  FileUpload: Q,
  FileUploadButton: X,
  Heading: Y,
  Icon: Z,
  Link: cr,
  Pagination: rr,
  Progress: er,
  VerificationCode: fr,
  Radio: nr,
  Select: pr,
  Slider: ur,
  Snackbar: lr,
  SnackbarContainer: mr,
  StarRating: tr,
  Status: ar,
  Spinner: or,
  Switch: hr,
  Tabs: dr,
  Text: ir,
  TextInput: _r,
  Textarea: Cr,
  FormField: vr,
  Tooltip: sr,
  Checkbox: Sr,
  cardStyles: L
}, C = {
  FairPrice: I,
  FairPriceCard: P,
  PageWrapper: F,
  ProfileMenu: br,
  ProfileMenuSeparator: Pr,
  ProfileMenuItem: Ir,
  BenchmarkChart: T,
  BenchmarkSlider: w,
  PopoverMenu: A,
  PopoverMenuItem: B,
  PopoverMenuSeparator: N,
  Separator: $,
  Skeleton: {
    Wrapper: M,
    GreyBlock: j,
    SpacerBlock: R,
    Row: D,
    Column: H
  },
  FilterMenu: z,
  AlertDialogProvider: Rr
}, We = {
  useAutoResizeTextarea: y,
  useResizeObserver: g,
  useScrollHeight: k,
  useAlertDialog: x
}, Ee = {
  ErrorContext: b
};
export {
  Rr as A,
  Wr as B,
  C,
  We as H,
  br as P,
  t as V,
  Ir as a,
  Pr as b,
  Ee as c
};
